import { PremiumStoreApiClient } from '@wix/premium-fed-sdk/@api-clients-react';
import { getOfferingPurchasableCycles } from '../utils';
export const queryAvailableCycles = async _ref => {
  let {
    httpClient,
    request
  } = _ref;
  const dynamicOffering = await PremiumStoreApiClient.query.getUserOffering({
    httpClient,
    request: {
      productTypeId: request.productTypeId,
      msid: request.msid
    }
  });
  return {
    cycles: getOfferingPurchasableCycles(dynamicOffering.products)
  };
};
//# sourceMappingURL=queryAvailableCycles.api-function.js.map